<literax-sign-document
  [currentCertName]="data.currentCertName"
  [showCancel]="data.showCancel"
  [document]="data.document"
  (cancelClicked)="closeModal()"
  [requiredCertificated]="data?.isRequiredCertificated"
  (submitClicker)= "signedFile()"
></literax-sign-document>
